import type { CSSProperties } from "react";

import { PROVENANCE_COPY } from "./provenance.constants.ts";
import type { StandingModel } from "./provenance.model.ts";

/**
 * How an entry is contested, beside the entry — OND-62.
 *
 * `EvidencePill`'s shape, and the two sit on the same card, so the distinction
 * between them is carried in the qualifier a screen reader hears: that one is
 * the SUBMITTER'S grade for their own evidence, this is what OTHER PEOPLE have
 * put on the record against the claim. Both audiences get told whose statement
 * it is, which is the rule `EvidencePill` already keeps.
 *
 * The sentence is rendered, not tooltipped. "QUESTIONABLE" alone invites the
 * reading this ticket exists to prevent — that somebody disputed the claim —
 * and the one thing a reader has to know is that nobody did.
 */
export function StandingPill({ standing }: { standing: StandingModel }) {
  return (
    <div className="provenance__standing">
      <span
        className="provenance__pill"
        style={
          { "--grade": standing.token, "--grade-bg": standing.bgToken } as CSSProperties
        }
      >
        <span className="provenance__sr">{PROVENANCE_COPY.standingQualifier} </span>
        {standing.label}
      </span>
      <p className="provenance__standing-note">
        {standing.sentence}
        {/* Only on the standing the documents caused — the model decided which,
            and there is no rule left here. */}
        {standing.documentNote !== null && (
          <>
            {" "}
            <strong>{standing.documentNote}</strong>
          </>
        )}
      </p>
    </div>
  );
}
